import { useSelector } from 'react-redux';
import { getUi } from '@ducks/ui/selectors';
import loadable from '@loadable/component';
import useUser from '@/hooks/useUser';
import { useUserAccess } from '@/hooks/useUserAccess';
import { getRegistrationFromNewsCookie } from '@/utilities/cookies';

const OnboardingModal = loadable(
  () => import('@/components/Onboarding/components/OnboardingModal'),
  {
    ssr: false,
  }
);

function Onboarding() {
  const ui = useSelector(getUi);
  const { data: user } = useUser();
  const { data: access } = useUserAccess();
  const isRegistrationFromNews =
    user.loggedIn && getRegistrationFromNewsCookie();
  const showModal =
    (ui.showOnboarding &&
      user.loggedIn &&
      (access.planType === 'premium' || access.planType === 'free') &&
      user.billing.status === 'trialing' &&
      RUNTIME_ENV !== 'server') ||
    isRegistrationFromNews;

  if (!showModal) {
    return null;
  }

  return <OnboardingModal />;
}

export default Onboarding;
